export default __webpack_public_path__ + "static/media/2408247.3bbf899c.webp";